import React from "react";
import { Box } from "@rebass/grid";
import { Update } from "./style";

// Static incident update content – direct JSX, no functions
const STATIC_UPDATE_MESSAGE = (
  <>
    <p style={{ marginBottom: "1em" }}>
      <strong>We are pleased to share that significant progress has been made in restoring services following the recent UAE data center disruption. We have begun bringing services back online in the Europe region for affected accounts after securely migrating data to our EU region. The restoration is being carried out in phases based on technical parameters to ensure data integrity and security.</strong>
    </p>
    <strong>What do I need to do?</strong>
    <p style={{ marginTop: "0.5em", marginBottom: "1em" }}>
      To return to normal operations, please review the following two actions (Please ignore if you have already responded):
    </p>
    <p style={{ marginBottom: "0.5em" }}>
      1. <strong>Confirm "yes"</strong>: We cannot restore your services without this confirmation. If you have not yet done so, please <a href="https://info.freshworks.com/NDg4LVRXWC03OTMAAAGgdZSVv4AgxE0xXmFgFNBkkOyV1SOVMyIBjhcK67bLMxPJvq_oMXVdFj0CeSVTrpHgf0IHsvU=" className="message-link" target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}><strong>click here</strong></a> to confirm "Yes" or email{" "}
      <a href="mailto:support@freshworks.com" className="message-link" onClick={(e) => e.stopPropagation()}>support@freshworks.com</a> to proceed with the restoration of your services in the EU region.
    </p>
    <p style={{ marginLeft: "1em", marginBottom: "1em", fontStyle: "italic" }}>
      • If you have already confirmed "yes" in writing, no further action is required from you.
    </p>
    <p style={{ marginBottom: "1em" }}>
      2. Please review the <a href="https://support.freshservice.com/support/solutions/articles/50000012022-mec-to-eun-migration-guide" className="message-link" target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>MEC to EUN Migration Guide</a> to ensure readiness as your instance is restored in the Europe region.
    </p>
    <strong>How will I know when my services are restored?</strong>
    <p style={{ marginTop: "0.5em", marginBottom: "1em" }}>
      You will hear from us as soon as your account has been restored and tested for successful operation.
    </p>
    <strong>Whom do I contact with questions?</strong>
    <p style={{ marginTop: "0.5em", marginBottom: "1em" }}>
      If you have questions regarding the migration or technical requirements, please email{" "}
      <a href="mailto:support@freshworks.com" className="message-link" onClick={(e) => e.stopPropagation()}>support@freshworks.com</a> or reach out directly to your customer success manager.
    </p>
    <p style={{ marginTop: "1em" }}>
      We appreciate your continued patience as we work to bring your systems back online as quickly and securely as possible.
    </p>
  </>
);

const IncidentUpdatesList = (props) => {
  const { incidentUpdates } = props;
  return (
    <div className="updatesWrapper">
      {incidentUpdates.map((item) => (
        <Update key={item.id} className="incident-updates">
          <Box className="update-label" width={1 / 6}>
            <div className="time">{props.getDisplayTime(item.created_at)}</div>
          </Box>
          <Box className="update-message" width={4 / 6}>
            {STATIC_UPDATE_MESSAGE}
          </Box>
        </Update>
      ))}
    </div>
  );
};

export default IncidentUpdatesList;

export const RecentIncidentUpdate = ({ incidentUpdates }) => {
  if (!incidentUpdates?.length) return null;
  return (
    <div className="recents">
      <Box mb={3}>
        <span className="message" style={{ lineHeight: '18px' }}>
          {STATIC_UPDATE_MESSAGE}
        </span>
      </Box>
    </div>
  );
};
